import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    comms: {
      custom: 0
    },
  },
  comms: []
});

const getters = {};

const mutations = {
  setOneFilter(state, [filterName, filter, value]) {
    state.filters[filterName][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  resetCommsFilters(state) {
    // Make sure to update state default
    state.filters.comms = {
      custom: 0
    };

    store.dispatch('updateUserAppFilter')
  },
};

const actions = {};

const CommsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default CommsStore;
